/* eslint-disable */
import React, {useState} from "react";
import {createUseStyles, useTheme} from "react-jss";

import FormDev from "../../../../../../artibulles-cis/FormDev/FormDev";
import _ from "lodash";
import FormSubmitButtons from "../../../../../../artibulles-cis/FormSubmitButtons/FormSubmitButtons";
import ExpandableBox from "../../../../../../artibulles-cis/ExpandableBox/ExpandableBox";
/************** NEW COMPONENTS **************/

import FormCompontent from "../../../../../../artibulles-cis/FormComponent/FormCompontent";
import CheckBox from "../../../../../../artibulles-cis/CheckBox/CheckBox";
import FileUploader from "../../../../../../artibulles-cis/FileUploader/FileUploader";
import {ArrowFilledLeft, ArrowFilledRight, AvatarV2, Login} from "@artibulles-cis/react-icons";
import {formatISO} from "date-fns";
/************** NEW COMPONENTS **************/

const styles = createUseStyles((theme) => ({
    FormWrapper: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        // border: "1px solid grey",
        padding: "10px",
        // height: "100%",
        color: "black",
    },
    FormTitle_Wrapper: {
        display: "flex",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "500px",
        boxSizing: "border-box",
    },
    FormTitle_Box: {
        display: "flex",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "500px",
        height: "60px",
        border: "1px solid grey",
        borderRadius: "3px",
        boxSizing: "border-box",
        padding: "5px 10px",
    },
    FormTitle_Logo_Wrapper: {
        flex: "0 0 50px",
        boxSizing: "border-box",
        borderRadius: "3px",
        padding: "4px",
        border: "1px solid grey",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    FormTitle_Logo: {
        width: "43px",
        height: "auto",
    },
    FormTitle_Title_Wrapper: {
        flex: "1 1 auto",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "flex-start",
        padding: "0px 0px 0px 10px",
        alignItems: "center",
    },
    FormTitle_Title: {
        fontFamily: "Roboto",
        fontWeight: "400",
        fontSize: "22px",
        margin: "0px",
    },

    FormSection: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        borderBottom: "2px solid grey",
        padding: "10px",
        marginBottom: "20px",
    },
    FormSectionTitle: {
        margin: "0px 0px 10px 0px",
    },
    FormSectionContent: {
        display: "flex",
        flexDirection: "column",
        padding: "0px 0px 0px 5px",
    },
    FormFieldCenteredMaxWidth: {
        flex: "0 1 600px",
    },
    FormMultilineFlex: {
        display: "flex",
        flexDirection: "row",
        margin: "4px 0px 4px 0px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
    },
    FormFieldMultiLineMaxWidth: {
        flex: "0 1 300px",
        margin: "0px 0px 0px 0px",
    },
    FormFieldMultiLineLeft: {
        flex: "0 1 300px",
    },
    FormField: {
        flex: "0 1 600px",
        margin: "5px 10px 5px 10px",
    },
    FormFieldCheckBoxAligned: {
        flex: "0 1 600px",
        margin: "0px 10px 0px 10px",
    },

    FormFieldSwitchBoxAligned: {
        flex: "0 1 600px",
        margin: "0px 10px 0px 10px",
    },
    ButtonBar: {
        display: "flex",
        flexWrap: "wrap",
        flex: "1 1 700px",
        justifyContent: "flex-start",
        alignItems: "center",
        boxSizing: "border-box",
        position: "relative",
        padding: "8px 20px 8px 20px",
    },
    tooltipP: {
        fontSize: "14px",
        padding: "0px",
    },
    FormLeft: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        position: "relative",
    },
    FormErrorMainMessage: {
        display: "flex",
        padding: "5px",
        boxSizing: "border-box",
        color: "orange",
    },
}));

const Component = React.memo(function Component(props) {
    const {
        DevMode = true, //used to check the form content wihtout sending it to the server
        FormData, //Load the Data into the form FormData = {SelectOptions:{option1 : [value :"", label :""]},InitiaFormValues : {}}
        OnSubmitExternal, //A function that hanldes the sumbission const OnSubmitExternal = FullSubmission=>{console.log(FullSubmission)}
        DisableToolTip = false, //To Enable or disable the Tooltip if required
        ButtonSaveAsDraft,
        ButtonSaveAndQuit,
        ButtonQuitNoSave,
        ButtonDelete,
        ButtonPublish,
        ButtonReset,
        ButtonNext,
        ButtonPrevious,
        OpenInViewMode,
        SwitchEditMode,
    } = props;

    const theme = useTheme();
    const classes = styles({...props, theme});

    /**************** REQUIRED STATE (DONT NEED TO BE UPDATED NORMALLY) *****************/
    const [FormDataInitReady, setFormDataInitReady] = useState(false); //PREVENT RENDERING THE FORM WHEN DATA IS NOT READY YET
    const [InitialFormValues, setInitialFormValues] = React.useState({}); //INITIAL FORM VALUES
    const [FormValues, setFormValues] = React.useState({}); //FINAL FORM VALUES
    const [FieldOptions, setFieldOptions] = React.useState({}); //FORM OPTIONS FOR SELECT
    const [NewFieldOptions, setNewFieldOptions] = React.useState({}); //Used for CreatableSelect to pass back to the server
    const [FieldSubOptionsFull, setFieldSubOptionsFull] = React.useState({}); //FORM SUBOPTIONS FOR SELECT
    const [FilesUploaders, setFilesUploaders] = React.useState({});
    const [Invalid, setInvalid] = useState(false); //Form has invalid fields
    const [Pristine, setPristine] = useState(true); //Form has been edited by the user -> Pristie === false
    const [PristineDetails, setPristineDetails] = useState({});
    const [FormViewMode, setFormViewMode] = useState();
    const [InitialFormErrors, setInitialFormErrors] = useState({});
    const [FormErrors, setFormErrors] = useState({}); //HNDLING FORM ERRORS
    const [InitialFormErrorMain, setInitialFormErrorMain] = useState(); //HNDLING FORM ERROR GLOBAL MESSAGE
    const [FormErrorMain, setFormErrorMain] = useState(); //HNDLING FORM ERROR GLOBAL MESSAGE

    /**************** REQUIRED STATE (DONT NEED TO BE UPDATED NORMALLY) *****************/
    /**************** VIEW OR EDIT MODE CONTROL *****************/
    React.useEffect(() => {
        if (OpenInViewMode === true) {
            if (SwitchEditMode === "EditButton") {
                setFormViewMode("EditButton");
            }
            if (SwitchEditMode === "FieldClick") {
                setFormViewMode("FieldClick");
            } else {
                setFormViewMode("View");
            }
        } else {
            setFormViewMode("Edit");
        }
    }, [OpenInViewMode, SwitchEditMode]);
    /**************** VIEW OR EDIT MODE CONTROL *****************/
    /**************** INITIAL FORM VALUES AND OPTIONS *****************/
    React.useEffect(() => {
        if (FormData) {
            if (FormData.SelectOptions) {
                //Cloning the object ????Why
                let LoadData = JSON.parse(JSON.stringify(FormData.SelectOptions));
                setFieldOptions(LoadData);
            }
            if (FormData.InitiaFormValues) {
                setInitialFormValues(FormData.InitiaFormValues);
                setFormValues(FormData.InitiaFormValues);
            }
            if (FormData.SubOptionsFull) {
                setFieldSubOptionsFull(FormData.SubOptionsFull);
            }
            if (FormData.FilesUploaders) {
                //Cloning the object
                let filesinit = JSON.parse(JSON.stringify(FormData.FilesUploaders));
                setFilesUploaders(filesinit);
            }
            if (FormData.InitiaFormErrors) {
                setInitialFormErrors(FormData.InitiaFormErrors);
                setFormErrors(FormData.InitiaFormErrors);
            }
            if (FormData.InitialFormErrorMain) {
                setInitialFormErrorMain(FormData.InitialFormErrorMain);
                setFormErrorMain(FormData.InitialFormErrorMain);
                //Set the form to invalid
                setInvalid(true);
            }
            setFormDataInitReady(true);
        }
    }, [FormData]);

    /**************** INITIAL FORM VALUES AND OPTIONS *****************/

    /**************** HANDLING SELECT CHANGE - INCLUDING SUB-SELECT *****************/
    const handleSelectChange = (field, SelectedDetails) => {
        //Hanlding the select change
        //Checking Pristine

        let FieldPristine = SelectedDetails.Pristine;
        let SelectedValues = SelectedDetails.Value;

        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/
        var FinalPristine = true;

        //Checking Pristine using the FieldResponse
        let PristineKeys = _.keys(PristineDetails);
        let UpdatedPristineDetails = PristineDetails;

        if (PristineKeys && PristineKeys.length > 0) {
            //Going through all the pristine fields to check if one of them is false
            var CurrentFieldHandled = false;
            PristineKeys.forEach((key) => {
                if (key === field) {
                    CurrentFieldHandled = true;
                    //Update the pristine value
                    UpdatedPristineDetails[field] = FieldPristine;
                    if (FieldPristine === false) {
                        FinalPristine = false;
                    }
                } else {
                    //just checking if false;
                    if (UpdatedPristineDetails[key] === false) {
                        FinalPristine = false;
                    }
                }
            });
            if (CurrentFieldHandled === false) {
                //The key wasn't there so we need to add it
                if (FieldPristine === false) {
                    UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                    FinalPristine = false;
                }
            }
        } else {
            //First field to be touched
            if (FieldPristine === false) {
                UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                FinalPristine = false;
            }
        }
        setPristineDetails(UpdatedPristineDetails);
        setPristine(FinalPristine);
        var UpdatedFormValues = {...FormValues, ...{[field]: SelectedValues}};
        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/

        /************* IF NO CONDITIONAL SELECT USE THIS *****************/
        setFormValues(UpdatedFormValues);
        /************* IF NO CONDITIONAL SELECT USE THIS *****************/

        /************* CONDITIONAL SELECT *****************/
        //To prevent having to deal with different server configuration, the logic to implement here must be tailored to your needs

        /*Option 1 :
         *Updating the options of a subfield based on the select value ->
         *If you use this, don't forget to specify that the conditional field is disabled if the parentField is empty or null
         */

        if (field === "ConditionalSelect1") {
            //We update the Options of the ConditionalSelect2
            let SubOptions = [];
            FieldSubOptionsFull.ConditionalSelect1.forEach((elem) => {
                if (elem.ref_ConditionalSelect1 === SelectedValues) {
                    let newsub = {value: elem.id, label: elem.name};
                    SubOptions.push(newsub);
                }
            });
            setFieldOptions({...FieldOptions, ...{ConditionalSelect2: SubOptions}});
            //We also need to reset the Conditional 2;
            setFormValues({...UpdatedFormValues, ...{ConditionalSelect2: null}});
        }
        if (field === "ConditionalSelect2") {
            //We update the Options of the ConditionalSelect3
            let SubOptions = [];
            FieldSubOptionsFull.ConditionalSelect2.forEach((elem) => {
                if (elem.ref_ConditionalSelect2 === SelectedValues) {
                    let newsub = {value: elem.id, label: elem.name};
                    SubOptions.push(newsub);
                }
            });
            setFieldOptions({...FieldOptions, ...{ConditionalSelect3: SubOptions}});
            //We also need to reset the Conditional 3;
            setFormValues({...UpdatedFormValues, ...{ConditionalSelect3: null}});
        }
    };
    /**************** HANDLING SELECT CHANGE - INCLUDING SUB-SELECT *****************/

    /**************** HANDLING ALL INPUT CHANGES EXCEPTED SELECT  *****************/

    const HandleUpdateFormValues = (field, values) => {
        let value = values.Value;
        let formattedValue = values.FormattedValue;
        let FieldPristine = values.Pristine;

        //Checking Pristine

        // Update the pristine based on the Field
        var FinalPristine = true;
        let PristineKeys = _.keys(PristineDetails);
        let UpdatedPristineDetails = PristineDetails;

        if (PristineKeys && PristineKeys.length > 0) {
            //Going through all the pristine fields to check if one of them is false
            var CurrentFieldHandled = false;
            PristineKeys.forEach((key) => {
                if (key === field) {
                    CurrentFieldHandled = true;
                    //Update the pristine value
                    UpdatedPristineDetails[field] = FieldPristine;
                    if (FieldPristine === false) {
                        FinalPristine = false;
                    }
                } else {
                    //just checking if false;
                    if (UpdatedPristineDetails[key] === false) {
                        FinalPristine = false;
                    }
                }
            });
            if (CurrentFieldHandled === false) {
                //The key wasn't there so we need to add it
                if (FieldPristine === false) {
                    UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                    FinalPristine = false;
                }
            }
        } else {
            //First field to be touched
            if (FieldPristine === false) {
                UpdatedPristineDetails = {...UpdatedPristineDetails, ...{[field]: false}};
                FinalPristine = false;
            }
        }
        var UpdateFormValues = {[field]: value};

        //Conditional Fields
        if (field === "is_VAT_Intracomm") {
            if (value === true) {
                //we Delete the values for the VAT amount  and the total without vat
                UpdateFormValues.vat_amount = null;
                UpdateFormValues.amount_without_vat = null;
            }
        }

        if (field === "accounting_Justification_needed") {
            if (value === false) {
                //We clear the justification provided
                //we clear the justification date

                UpdateFormValues.accounting_Justification_Provided = false;
                UpdateFormValues.accounting_Justification_Provided_Date = null;
            } else {
                UpdateFormValues.accounting_Justification_Provided = false;
                UpdateFormValues.accounting_Justification_Provided_Date = formatISO(new Date(Date.now()));
            }
        }

        setPristineDetails(UpdatedPristineDetails);
        setFormValues({...FormValues, ...UpdateFormValues});
        setPristine(FinalPristine);

        //Manual update the pristine
        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/
        // let FormValuesKeys = _.keys(FormValues);
        // var FinalPristine = true;

        // if (FormValuesKeys && FormValuesKeys.length > 0) {
        //     FormValuesKeys.forEach((key) => {
        //         let InitialValue = InitialFormValues[key];

        //         var Value;
        //         if (key !== field) {
        //             Value = FormValues[key];
        //         } else {
        //             //Check that the modified field is not the same as the InitalValue (The value has not changed yet)
        //             Value = value;
        //         }
        //         if (InitialValue === undefined) {
        //             InitialValue = null; //We set it to null to be able to compare to the Input Value that is set to null
        //             //It means that there was no initialValue passed to the form (that's the case when it is new)
        //         }
        //         if (InitialValue !== Value) {
        //             FinalPristine = false;
        //         }
        //     });
        // }

        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/

        //Confirm Errors
        ValidateForm(field, value);
        HandleFiedsChange(field, value);
    };

    const HandleUpdateErrors = (field, error) => {
        // console.log("HandleUpdateErrors", field, error);
        //We need to check if there is an error or not
        const ErrorsKeys = _.keys(FormErrors);
        var FinalErrors = {};
        var InvalidTemp = false;
        if (ErrorsKeys && ErrorsKeys.length > 0) {
            // If there is an error
            ErrorsKeys.forEach((key) => {
                if (key !== field) {
                    if (FormErrors[key]) {
                        //Add the error in the list
                        FinalErrors = {...FinalErrors, ...{[key]: FormErrors[key]}};
                        InvalidTemp = true;
                    }
                }
            });
        }

        if (error) {
            //Add the error in the list
            FinalErrors = {...FinalErrors, ...{[field]: error}};
            InvalidTemp = true;
        }
        // console.log("InfalErrors", FinalErrors);

        setFormErrors(FinalErrors);

        setInvalid(InvalidTemp);
    };

    /**************** HANDLING ALL INPUT CHANGES EXCEPTED SELECT  *****************/

    /**************** UPDATE THE OPTIONS WITH THE CREATED ONES IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/
    //Update the Select Creatable Options to add the new Options to the menu and transfer the new Options to the parent component
    const UpdateCreatableOptions = (field, UpdatedOptions) => {
        let FullNewOptions = UpdatedOptions.FullOptions;
        let NewOptions = UpdatedOptions.NewOptions;

        FieldOptions[field] = FullNewOptions;
        setNewFieldOptions({...NewFieldOptions, ...{[field]: NewOptions}});
        setFieldOptions(FieldOptions);
    };
    /**************** UPDATE THE OPTIONS WITH THE CREATED ONES IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/

    /**************** UPDATE THE FilesUploaders IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/
    //UPDATE THE UPLOADED FILES FIELDS IF ANY

    const UpdateFormFiles = (fieldName, filedetails) => {
        if (fieldName) {
            let FullFilesUploader = [];
            for (var i = 0; i < filedetails.length; i++) {
                FullFilesUploader.push({
                    serverPath: filedetails[i].serverPath,
                    originalName: filedetails[i].originalName,
                    downloadName: filedetails[i].downloadName,
                    fileExtension: filedetails[i].fileExtension,
                    fileType: filedetails[i].fileType,
                    fileSize: filedetails[i].fileSize,
                    keywords: filedetails[i].keywords,
                });
            }
            FilesUploaders[fieldName] = FullFilesUploader;

            setFilesUploaders(FilesUploaders);
        }
    };
    /**************** UPDATE THE FilesUploaders IF ANY (DONT NEED TO BE UPDATED NORMALLY) *****************/

    /**************** FORM SUBMISSION (DONT NEED TO BE UPDATED NORMALLY) *****************/

    const HandleSubmitForm = (submitType) => {
        /**Default SubmitType :
         * SaveDraft,
         * SaveAndQuit
         * QuitNoSave
         * reset //No Caps
         * Publish
         * Delete
         * NextSave
         * NextQuit
         * PreviousSave
         * PreviousQuit
         */
        if (submitType === "reset") {
            //Reinitializing the select options in case some were created
            let LoadData = JSON.parse(JSON.stringify(FormData.SelectOptions));
            setFieldOptions(LoadData);
            //Reinitializing the pristineDetails
            setPristineDetails({});
            //Reinitializing the CreatedOptions
            setNewFieldOptions({});

            //Reinitializing the FilesUplaoders
            let filesinit = JSON.parse(JSON.stringify(FormData.FilesUploaders));
            setFilesUploaders(filesinit);

            //Reinitializing the FormValues;

            setFormValues(InitialFormValues);

            //Reinitializing the Errors;

            setFormErrors(InitialFormErrors);

            //Setting the Form back to pristine
            setPristine(true);
        }
        if (typeof OnSubmitExternal === "function") {
            //If there are new created options, we need to pass them too with the value

            //WE ONLY PASS THE FORMVALUES THAT ARE DIFFERENT THAN THE INITALVALUES
            var FinalSubmittedValues = {};
            let FormValuesKeys = _.keys(FormValues);

            if (FormValuesKeys && FormValuesKeys.length > 0) {
                FormValuesKeys.forEach((key) => {
                    if (key === "ApiID") {
                        FinalSubmittedValues = {...FinalSubmittedValues, ...{[key]: FormValues[key]}};
                    }
                    //Get the IntialValue
                    let InitialValue = InitialFormValues[key];
                    let Value = FormValues[key];
                    if (InitialValue !== Value) {
                        FinalSubmittedValues = {...FinalSubmittedValues, ...{[key]: FormValues[key]}};
                    }
                });
            }

            let FullSubmission = {
                typeOfSubmit: submitType, //Just passing the reset in case the parent needs to know
                values: FinalSubmittedValues ? FinalSubmittedValues : null,
            };
            //Prevent passing new created options if there are no new options

            if (_.isEmpty(NewFieldOptions) === false) {
                FullSubmission.NewCreatedOptions = NewFieldOptions;
            }

            if (FilesUploaders) {
                FullSubmission.FilesUploader = FilesUploaders;
            }

            //Submitting
            OnSubmitExternal(FullSubmission);

            //Updating the form state for editing after it has been submitted to define the editing mode
            if (OpenInViewMode === true) {
                if (SwitchEditMode === "EditButton") {
                    setFormViewMode("EditButton");
                }
                if (SwitchEditMode === "FieldClick") {
                    setFormViewMode("FieldClick");
                } else {
                    setFormViewMode("View");
                }
            }
        } else {
            console.log("You didn't pass a function for an external submission");
        }
    };
    /**************** FORM SUBMISSION (DONT NEED TO BE UPDATED NORMALLY) *****************/

    /****************************************************************** EDITABLE SECTION ******************************************************************/

    /**************** FORM VALIDATION  *****************/
    const ValidateForm = (field, value) => {
        var UpdatedFormErrors = {...FormErrors};

        // if (field === "testval") {
        //     if (value) {
        //         if (value === "Caca") {
        //             UpdatedFormErrors.testval = "Caca is not allowed";
        //         }
        //     } else {
        //         UpdatedFormErrors.testval = "Cannot be empty";
        //     }
        // }

        // if (Object.keys(UpdatedFormErrors).length > 0) {
        //     setFormErrors(UpdatedFormErrors);
        //     setInvalid(true);
        // } else {
        //     setFormErrors({});
        //     setInvalid(false);
        // }
    };
    /**************** FORM VALIDATION  *****************/

    /**************** ON CHANGE UPDATES  *****************/

    const HandleFiedsChange = (field, value) => {
        // if (field === "isSubsidiary") {
        //     if (value === false) {
        //         setFormValues({...FormValues, ...{ref_group: null, isSubsidiary: false}});
        //     } else {
        //         setFormValues({...FormValues, ...{[field]: value}});
        //     }
        // }
    };

    /**************** ON CHANGE UPDATES  *****************/

    /**************** CUSTOM FUNCTIONS  *****************/
    const HandleEnableEditMode = () => {
        setFormViewMode("Edit");
    };

    /**************** CUSTOM FUNCTIONS  *****************/

    /****************************************************************** EDITABLE SECTION ******************************************************************/

    var FinalFormComponent;

    if (FormDataInitReady === true) {
        FinalFormComponent = (
            <div className={classes.FormWrapper}>
                <h1 style={{margin: "0 auto"}}>Edit Account Transaction Entry</h1>
                <ExpandableBox
                    TopContent={<h3 style={{margin: "0px", textAlign: "center"}}>Transaction information</h3>}
                    DefaultStyle="List"
                    // TransitionEffect={{Duration : "600ms"}}
                    // MaxWidth="1020px"
                    // CustomController={<InfoCircleBlue />}
                    // CustomControllerNoRotation={true}
                    // BackgroundColorTopBar="grey"
                    // ClassExtendsExpandableBox={classes.ExpandableBox}
                    // ClassExtends_ExpandableBox_Controller_Wrapper={classes.ClassExtends_ExpandableBox_Controller_Wrapper}
                    // ClassExtendsTopContentWrapper={classes.TopContentWrapper}
                    // ClassExtendsContentOpenedWrapper={classes.ContentOpenedWrapper}
                    // ClassExtendsIconControllerStyle={classes.ClassExtendsIconControllerStyle}
                    // MinWidth="1020px"
                    // MaxHeightClosed={MainExpandableConfig.MaxHeightClosed}
                    MaxHeightOpened="150px"
                    OpenOnTopClick={true}
                    WithPerfectScrollbar={false}
                    WithScrollbar={null}
                    FlexMode={true}
                >
                    <div className={classes.FormMultilineFlex}>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="transaction_date_Iso"
                                InitialValue={InitialFormValues.transaction_date_Iso ? InitialFormValues.transaction_date_Iso : null}
                                FormValue={FormValues.transaction_date_Iso ? FormValues.transaction_date_Iso : null}
                                OutputValue={(values) => HandleUpdateFormValues("transaction_date_Iso", values)}
                                OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Imask={true}
                                NoMessage={true}
                                Mask={{
                                    Type: "Date",
                                    Options: {
                                        Format: "yyyy/MM/dd",
                                    },
                                }}
                                Label="Transaction date"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="banking_effective_date_Iso"
                                InitialValue={InitialFormValues.banking_effective_date_Iso ? InitialFormValues.banking_effective_date_Iso : null}
                                FormValue={FormValues.banking_effective_date_Iso ? FormValues.banking_effective_date_Iso : null}
                                OutputValue={(values) => HandleUpdateFormValues("banking_effective_date_Iso", values)}
                                OutputError={(error) => HandleUpdateErrors("banking_effective_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Imask={true}
                                NoMessage={true}
                                Mask={{
                                    Type: "Date",
                                    Options: {
                                        Format: "yyyy/MM/dd",
                                    },
                                }}
                                Label="Banking date"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="banking_amount_transaction"
                                InitialValue={InitialFormValues.banking_amount_transaction ? InitialFormValues.banking_amount_transaction : 0}
                                FormValue={FormValues.banking_amount_transaction ? FormValues.banking_amount_transaction : 0}
                                OutputValue={(values) => HandleUpdateFormValues("banking_amount_transaction", values)}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Label="Bank amount"
                                NoMessage={false}
                                meta={{error: FormErrors.task_name, invalid: FormErrors.task_name ? true : false}}
                                OutputError={(error) => HandleUpdateErrors("task_name", error)}
                                // LegendOffsetHeight="0"
                                // LegendOffsetWidth="0"
                                LabelMaxWidth="200px"
                                LabelAlign="Left"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="original_amount_transaction"
                                InitialValue={InitialFormValues.original_amount_transaction ? InitialFormValues.original_amount_transaction : null}
                                FormValue={FormValues.original_amount_transaction ? FormValues.original_amount_transaction : null}
                                OutputValue={(values) => HandleUpdateFormValues("original_amount_transaction", values)}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Label="Orignal amount"
                                NoMessage={false}
                                // meta={{error: FormErrors.task_name, invalid: FormErrors.task_name ? true : false}}
                                OutputError={(error) => HandleUpdateErrors("task_name", error)}
                                // LegendOffsetHeight="0"
                                // LegendOffsetWidth="0"
                                LabelMaxWidth="200px"
                                LabelAlign="Left"
                                ReadOnly={true}
                            />
                        </div>
                    </div>
                    <div className={classes.FormMultilineFlex}>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="type_expense_income"
                                InitialValue={InitialFormValues.type_expense_income ? InitialFormValues.type_expense_income : null}
                                FormValue={FormValues.type_expense_income ? FormValues.type_expense_income : null}
                                OutputValue={(values) => HandleUpdateFormValues("type_expense_income", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Income / Expense"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="transaction_source"
                                InitialValue={InitialFormValues.transaction_source ? InitialFormValues.transaction_source : null}
                                FormValue={FormValues.transaction_source ? FormValues.transaction_source : null}
                                OutputValue={(values) => HandleUpdateFormValues("transaction_source", values)}
                                // OutputError={(error) => HandleUpdateErrors("banking_effective_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Source"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.myCompany_bankAccount_number ? null : "none"}`}}>
                            <FormCompontent
                                Name="myCompany_bankAccount_number"
                                InitialValue={InitialFormValues.myCompany_bankAccount_number ? InitialFormValues.myCompany_bankAccount_number : null}
                                FormValue={FormValues.myCompany_bankAccount_number ? FormValues.myCompany_bankAccount_number : 0}
                                OutputValue={(values) => HandleUpdateFormValues("myCompany_bankAccount_number", values)}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Label="Bank Account Number"
                                NoMessage={false}
                                // meta={{error: FormErrors.task_name, invalid: FormErrors.task_name ? true : false}}
                                // OutputError={(error) => HandleUpdateErrors("task_name", error)}
                                // LegendOffsetHeight="0"
                                // LegendOffsetWidth="0"
                                LabelMaxWidth="200px"
                                LabelAlign="Left"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.credit_card_number ? null : "none"}`}}>
                            <FormCompontent
                                Name="credit_card_number"
                                InitialValue={InitialFormValues.credit_card_number ? InitialFormValues.credit_card_number : null}
                                FormValue={FormValues.credit_card_number ? FormValues.credit_card_number : 0}
                                OutputValue={(values) => HandleUpdateFormValues("credit_card_number", values)}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Label="Credit Card Number"
                                NoMessage={false}
                                // meta={{error: FormErrors.task_name, invalid: FormErrors.task_name ? true : false}}
                                // OutputError={(error) => HandleUpdateErrors("task_name", error)}
                                // LegendOffsetHeight="0"
                                // LegendOffsetWidth="0"
                                LabelMaxWidth="200px"
                                LabelAlign="Left"
                                ReadOnly={true}
                            />
                        </div>
                    </div>
                    <div className={classes.FormMultilineFlex} style={{display: `${FormValues.myCompany_bankAccount_number ? null : "none"}`}}>
                        <div className={classes.FormField} style={{flex: "0 1 350px"}}>
                            <FormCompontent
                                Name="counterparty_bankAccount_number"
                                InitialValue={InitialFormValues.counterparty_bankAccount_number ? InitialFormValues.counterparty_bankAccount_number : null}
                                FormValue={FormValues.counterparty_bankAccount_number ? FormValues.counterparty_bankAccount_number : null}
                                OutputValue={(values) => HandleUpdateFormValues("counterparty_bankAccount_number", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Account Number"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "0 1 80px"}}>
                            <FormCompontent
                                Name="counterparty_bankAccount_bic"
                                InitialValue={InitialFormValues.counterparty_bankAccount_bic ? InitialFormValues.counterparty_bankAccount_bic : null}
                                FormValue={FormValues.counterparty_bankAccount_bic ? FormValues.counterparty_bankAccount_bic : null}
                                OutputValue={(values) => HandleUpdateFormValues("counterparty_bankAccount_bic", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="BIC"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "0 1 120px"}}>
                            <FormCompontent
                                Name="counterparty_bankAccount_name"
                                InitialValue={InitialFormValues.counterparty_bankAccount_name ? InitialFormValues.counterparty_bankAccount_name : null}
                                FormValue={FormValues.counterparty_bankAccount_name ? FormValues.counterparty_bankAccount_name : null}
                                OutputValue={(values) => HandleUpdateFormValues("counterparty_bankAccount_name", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Owner"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="counterparty_bankAccount_address"
                                InitialValue={InitialFormValues.counterparty_bankAccount_address ? InitialFormValues.counterparty_bankAccount_address : null}
                                FormValue={FormValues.counterparty_bankAccount_address ? FormValues.counterparty_bankAccount_address : null}
                                OutputValue={(values) => HandleUpdateFormValues("counterparty_bankAccount_address", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Address"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                    </div>
                    <div className={classes.FormMultilineFlex} style={{display: `${FormValues.credit_card_number ? null : "none"}`}}>
                        <div className={classes.FormField} style={{flex: "0 1 350px"}}>
                            <FormCompontent
                                Name="location"
                                InitialValue={InitialFormValues.location ? InitialFormValues.location : null}
                                FormValue={FormValues.location ? FormValues.location : null}
                                OutputValue={(values) => HandleUpdateFormValues("location", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="location"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "0 1 80px"}}>
                            <FormCompontent
                                Name="merchant"
                                InitialValue={InitialFormValues.merchant ? InitialFormValues.merchant : null}
                                FormValue={FormValues.merchant ? FormValues.merchant : null}
                                OutputValue={(values) => HandleUpdateFormValues("merchant", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="merchant"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="communication"
                                InitialValue={InitialFormValues.communication ? InitialFormValues.communication : null}
                                FormValue={FormValues.communication ? FormValues.communication : null}
                                OutputValue={(values) => HandleUpdateFormValues("communication", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Communication"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                    </div>
                    <div className={classes.FormMultilineFlex} style={{display: `${FormValues.myCompany_bankAccount_number ? null : "none"}`}}>
                        <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                            <FormCompontent
                                Name="communication"
                                InitialValue={InitialFormValues.communication ? InitialFormValues.communication : null}
                                FormValue={FormValues.communication ? FormValues.communication : null}
                                OutputValue={(values) => HandleUpdateFormValues("communication", values)}
                                // OutputError={(error) => HandleUpdateErrors("transaction_date_Iso", error)}
                                // meta={{error: FormErrors.mask_date, invalid: FormErrors.mask_date ? true : false}}
                                Component="Input"
                                Variant="OutlinedLabel"
                                NoMessage={true}
                                Label="Communication"
                                DisplayMessageIn="Popup"
                                ReadOnly={true}
                            />
                        </div>
                    </div>
                </ExpandableBox>
                <ExpandableBox
                    TopContent={<h3 style={{margin: "0px", textAlign: "center"}}>Transaction details</h3>}
                    DefaultStyle="List"
                    // TransitionEffect={{Duration : "600ms"}}
                    // MaxWidth="1020px"
                    // CustomController={<InfoCircleBlue />}
                    // CustomControllerNoRotation={true}
                    // BackgroundColorTopBar="grey"
                    // ClassExtendsExpandableBox={classes.ExpandableBox}
                    // ClassExtends_ExpandableBox_Controller_Wrapper={classes.ClassExtends_ExpandableBox_Controller_Wrapper}
                    // ClassExtendsTopContentWrapper={classes.TopContentWrapper}
                    // ClassExtendsContentOpenedWrapper={classes.ContentOpenedWrapper}
                    // ClassExtendsIconControllerStyle={classes.ClassExtendsIconControllerStyle}
                    // MinWidth="1020px"
                    // MaxHeightClosed={MainExpandableConfig.MaxHeightClosed}
                    MaxHeightOpened="150px"
                    OpenOnTopClick={true}
                    WithPerfectScrollbar={false}
                    WithScrollbar={null}
                    FlexMode={true}
                >
                    <div className={classes.FormMultilineFlex} style={{justifyContent: "flex-start", width: "1200px"}}>
                        <div className={classes.FormFieldCheckBoxAligned} style={{flex: "0 1 300px"}}>
                            <CheckBox
                                Inputname="accounting_Justification_needed"
                                label="Accounting justification required"
                                initialvalue={InitialFormValues.accounting_Justification_needed === true ? true : false}
                                curvalue={FormValues.accounting_Justification_needed}
                                ShareInputValue={(value) => HandleUpdateFormValues("accounting_Justification_needed", value)}
                            />
                        </div>
                        <div className={classes.FormFieldCheckBoxAligned} style={{flex: "0 1 310px", display: `${FormValues.accounting_Justification_needed === true ? "flex" : "none"}`}}>
                            <CheckBox
                                Inputname="accounting_Justification_Provided"
                                label="Accounting justification provided"
                                initialvalue={InitialFormValues.accounting_Justification_Provided === true ? true : false}
                                curvalue={FormValues.accounting_Justification_Provided}
                                ShareInputValue={(value) => HandleUpdateFormValues("accounting_Justification_Provided", value)}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.accounting_Justification_Provided === true ? "flex" : "none"}`}}>
                            <FormCompontent
                                Name="accounting_Justification_Provided_Date"
                                InitialValue={InitialFormValues.accounting_Justification_Provided_Date ? InitialFormValues.accounting_Justification_Provided_Date : null}
                                FormValue={FormValues.accounting_Justification_Provided_Date ? FormValues.accounting_Justification_Provided_Date : null}
                                OutputValue={(values) => HandleUpdateFormValues("accounting_Justification_Provided_Date", values)}
                                OutputError={(error) => HandleUpdateErrors("accounting_Justification_Provided_Date", error)}
                                meta={{error: FormErrors.accounting_Justification_Provided_Date, invalid: FormErrors.accounting_Justification_Provided_Date ? true : false}}
                                Variant="Outlined"
                                Component="DatePicker"
                                PickerDateType="Calendar"
                                PickerOnly={false}
                                InputFormat="dd/MM/yyyy"
                                NoMessage={false}
                                Label="Provided to accountant date"
                                LabelMaxWidth="300px"
                                LabelAlign="Left"
                                DisplayMessageIn="Popup"
                                Required={true}
                            />
                        </div>
                    </div>

                    <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                        <FormCompontent
                            Name="customer_name"
                            InitialValue={InitialFormValues.customer_name ? InitialFormValues.customer_name : null}
                            FormValue={FormValues.customer_name ? FormValues.customer_name : null}
                            OutputValue={(values) => HandleUpdateFormValues("customer_name", values)}
                            Component="Input"
                            Variant="Outlined"
                            Label="Customer Name"
                            NoMessage={false}
                            // meta={{error: FormErrors.date_calendarNokeyboard, invalid: FormErrors.date_calendarNokeyboard ? true : false}}
                            // OutputError={(error) => HandleUpdateErrors("date_calendarNokeyboard", error)}
                            // LegendOffsetHeight="0"
                            // LegendOffsetWidth="0"

                            LabelMaxWidth="200px"
                            LabelAlign="Left"
                        />
                    </div>
                    <div className={classes.FormField} style={{flex: "1 1 350px"}}>
                        <FileUploader
                            name="accounting_Justification_File_Path"
                            label="Transactions"
                            APIUploadPath="/api/companyaccount/uploadvatjustification"
                            APIDeletePath="/api/companyaccount/deleteuploadedvatjustification"
                            UpdateFormFunction={UpdateFormFiles}
							DownloadName="CacaBoudin"
                            MaxFiles={10}
                            MaxSizeMB={10}
                            InitialFiles={FilesUploaders ? FilesUploaders.accounting_Justification_File_Path : []}
                            UploadButton={{
                                Message: "Upload Justification",
                            }}
                            // AcceptedFileTypes={["*"]}
                            AcceptedFileTypes={["pdf"]}
                            MessageDragAndDrop={{DragColor: "grey", DragMessage: "Drag your files here", DropMessage: "Drop files"}}
                            BorderStyles={{EmptyColor: "grey", DraggingColor: "blue"}}
                            SelectStyle={{WithIcons: true, BackgroundColor: "grey", Color: "white"}}
                            WithDragAndDrop={true}
                            WithProgressBar={true}
                            ProgressBarStyle={{EmptyColor: "grey", ProgressColor: "blue"}}
                        />
                    </div>
                    <div className={classes.FormMultilineFlex} style={{justifyContent: "flex-start", width: "1200px"}}>
                        <div className={classes.FormFieldCheckBoxAligned} style={{flex: "0 1 300px"}}>
                            <CheckBox
                                Inputname="is_VAT_Intracomm"
                                label="Intracom VAT"
                                initialvalue={InitialFormValues.is_VAT_Intracomm === true ? true : false}
                                curvalue={FormValues.is_VAT_Intracomm}
                                ShareInputValue={(value) => HandleUpdateFormValues("is_VAT_Intracomm", value)}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.is_VAT_Intracomm === false ? "flex" : "none"}`}}>
                            <FormCompontent
                                Name="vat_amount"
                                InitialValue={InitialFormValues.vat_amount ? InitialFormValues.vat_amount : null}
                                FormValue={FormValues.vat_amount ? FormValues.vat_amount : null}
                                OutputValue={(values) => HandleUpdateFormValues("vat_amount", values)}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Imask={true}
                                Mask={{
                                    Type: "Currency",
                                    Options: {
                                        Currency: "EUR",
                                        // SymbolPosition: "Post",
                                        Scale: 2,
                                    },
                                }}
                                Label="VAT Amount"
                                // meta={{error: FormErrors.mask_currency_usd, invalid: FormErrors.mask_currency_usd ? true : false}}
                                // OutputError={(error) => HandleUpdateErrors("mask_currency_usd", error)}
                                DisplayMessageIn="Popup"
                                Required={true}
                            />
                        </div>
                        <div className={classes.FormField} style={{flex: "1 1 auto", display: `${FormValues.is_VAT_Intracomm === false ? "flex" : "none"}`}}>
                            <FormCompontent
                                Name="amount_without_vat"
                                InitialValue={InitialFormValues.amount_without_vat ? InitialFormValues.amount_without_vat : null}
                                FormValue={FormValues.amount_without_vat ? FormValues.amount_without_vat : null}
                                OutputValue={(values) => HandleUpdateFormValues("amount_without_vat", values)}
                                Component="Input"
                                Variant="OutlinedLabel"
                                Imask={true}
                                Mask={{
                                    Type: "Currency",
                                    Options: {
                                        Currency: "EUR",
                                        // SymbolPosition: "Post",
                                        Scale: 2,
                                    },
                                }}
                                Label="Amount without VAT"
                                // meta={{error: FormErrors.mask_currency_usd, invalid: FormErrors.mask_currency_usd ? true : false}}
                                // OutputError={(error) => HandleUpdateErrors("mask_currency_usd", error)}
                                DisplayMessageIn="Popup"
                                Required={true}
                            />
                        </div>
                    </div>
                    <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                        <FormCompontent
                            Name="accouting_communication"
                            InitialValue={InitialFormValues.accouting_communication ? InitialFormValues.accouting_communication : null}
                            FormValue={FormValues.accouting_communication ? FormValues.accouting_communication : null}
                            OutputValue={(values) => HandleUpdateFormValues("accouting_communication", values)}
                            Component="Input"
                            Variant="Outlined"
                            Label="Accounting communication"
                            NoMessage={false}
                            meta={{error: FormErrors.accouting_communication, invalid: FormErrors.accouting_communication ? true : false}}
                            OutputError={(error) => HandleUpdateErrors("accouting_communication", error)}
                            // LegendOffsetHeight="0"
                            // LegendOffsetWidth="0"
                            LabelMaxWidth="200px"
                            multiline={true}
                            RowsToDisplay="3"
                            MaxRows="3"
                            LabelAlign="Left"
                            Required={false}
                        />
                    </div>

                    <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                        <FormCompontent
                            Name="accounting_note"
                            InitialValue={InitialFormValues.accounting_note ? InitialFormValues.accounting_note : null}
                            FormValue={FormValues.accounting_note ? FormValues.accounting_note : null}
                            OutputValue={(values) => HandleUpdateFormValues("accounting_note", values)}
                            Component="Input"
                            Variant="Outlined"
                            Label="Note for accounting company"
                            NoMessage={false}
                            meta={{error: FormErrors.accounting_note, invalid: FormErrors.accounting_note ? true : false}}
                            OutputError={(error) => HandleUpdateErrors("accounting_note", error)}
                            // LegendOffsetHeight="0"
                            // LegendOffsetWidth="0"
                            LabelMaxWidth="200px"
                            multiline={true}
                            RowsToDisplay="3"
                            MaxRows="3"
                            LabelAlign="Left"
                            Required={false}
                        />
                    </div>

                    <div className={classes.FormField} style={{flex: "1 1 auto"}}>
                        <FormCompontent
                            Name="ref_taskCategory"
                            InitialValue={InitialFormValues.ref_taskCategory ? InitialFormValues.ref_taskCategory : null}
                            FormValue={FormValues.ref_taskCategory ? FormValues.ref_taskCategory : null}
                            OutputSelectedValues={(values) => handleSelectChange("ref_taskCategory", values)}
                            SelectOptions={FieldOptions.ref_taskCategory}
                            Component="Select"
                            Variant="Outlined"
                            Label="Category"
                            NoMessage={false}
                            meta={{error: FormErrors.ref_taskCategory, invalid: FormErrors.ref_taskCategory ? true : false}}
                            OutputError={(error) => HandleUpdateErrors("ref_taskCategory", error)}
                            MultiSelect={false}
                            SortSelectOptions="Asc"
                            // SortIcons={true}
                            AllowCreateOption={true}
                            // CreateDeleteIfUnselected={}
                            UpdateCreatableOptions={(options) => UpdateCreatableOptions("ref_taskCategory", options)}
                            LabelMaxWidth="200px"
                            LabelAlign="Left"
                        />
                    </div>
                </ExpandableBox>

                <FormDev
                    DevMode={DevMode}
                    FormValues={FormValues}
                    InitialFormValues={InitialFormValues}
                    FieldOptions={FieldOptions}
                    FieldSubOptionsFull={FieldSubOptionsFull}
                    FilesUploaders={FilesUploaders}
                    FormErrors={FormErrors}
                    NewFieldOptions={NewFieldOptions}
                    PristineDetails={PristineDetails}
                />
                {/* Button Bar */}
                <div className={classes.FormErrorMainMessage} style={{display: FormErrorMain ? null : "none"}}>
                    {`${FormErrorMain ? FormErrorMain : null}`}
                </div>
                <div style={{height: "80px"}}>
                    <FormSubmitButtons
                        ButtonSaveAsDraft={ButtonSaveAsDraft}
                        ButtonSaveAndQuit={ButtonSaveAndQuit}
                        ButtonQuitNoSave={ButtonQuitNoSave}
                        ButtonDelete={ButtonDelete}
                        ButtonPublish={ButtonPublish}
                        ButtonReset={ButtonReset}
                        ButtonNext={ButtonNext}
                        ButtonPrevious={ButtonPrevious}
                        HandleSubmitForm={HandleSubmitForm}
                        Invalid={Invalid}
                        Pristine={Pristine}
                        DisableToolTip={DisableToolTip}
                        FormViewMode={FormViewMode}
                    />
                </div>

                {/* Button Bar */}
            </div>
        );
    } else {
        FinalFormComponent = null;
    }
    return <div className={classes.FormWrapper}>{FinalFormComponent}</div>;
});
export default Component;
